'use client';

import cn from 'classnames';

import { Link } from '@/components/Link';
import { Wrapper } from '@/components/Wrapper';
import { useAnalytics } from '@/hooks/useAnalytics';
import { useWindowWidth } from '@/hooks/useWindowWidth';

import s from './Footer.module.scss';

const Logo = () => {
  return (
    <svg
      className={s.logo}
      xmlns="http://www.w3.org/2000/svg"
      width="433"
      height="433"
      viewBox="0 0 433 433"
      fill="none"
    >
      <path
        opacity="0.05"
        d="M0 82.475V350.522L205.674 433V1.32764e-05L0 82.475ZM433 207.271V82.475L227.326 1.32764e-05V207.271H433ZM227.326 225.726H433V350.522L227.326 433V225.726Z"
        fill="white"
      />
    </svg>
  );
};

const MOCK_SOCIALS = [
  {
    id: 'tg',
    src: 'https://cdn.cloud.ru/backend/career/socials/tg.svg',
    link: 'https://t.me/cloudruprovider',
  },
  {
    id: 'vk',
    src: 'https://cdn.cloud.ru/backend/career/socials/vk.svg',
    link: 'https://vk.com/cloudruprovider',
  },
  {
    id: 'youtube',
    src: 'https://cdn.cloud.ru/backend/career/socials/youtube.svg',
    link: 'https://www.youtube.com/@cloudru_team',
  },
  {
    id: 'habr',
    src: 'https://cdn.cloud.ru/backend/career/socials/habr.svg',
    link: 'https://habr.com/ru/companies/cloud_ru/articles/',
  },
];

const Copyright = () => {
  const date = new Date();

  return (
    <div className={cn(s.copy, s.title)}>
      &copy; {date.getFullYear()} Cloud.ru
    </div>
  );
};

const Footer = () => {
  const {
    windowWidth,
    breakpoints: { MD },
  } = useWindowWidth();

  const { clickAnalytics } = useAnalytics();

  return (
    <footer className={cn(s.root)}>
      <Wrapper className={s.wrapper}>
        <div className={s.col}>
          <h2 className={s.title}>Узнать о Cloud.ru больше:</h2>
          <div className={s.socials}>
            {MOCK_SOCIALS.map(({ id, src, link }, index) => {
              return (
                <Link
                  className={cn(s.social, 'link')}
                  href={link}
                  key={index}
                  prefetch={false}
                  analyticsOptions={{
                    action: link,
                    clickZone: 'footer',
                    clickElement: 'button',
                    clickContent: src,
                    uniqueId: id,
                    transitionType: 'outside-link',
                    clickZoneCategory: 'site-footer',
                    transitionUrl: link,
                    transitionTypeMetrics: 'external',
                  }}
                >
                  <img
                    className={s.icon}
                    src={src}
                    width={32}
                    height={32}
                    alt=""
                  />
                </Link>
              );
            })}
          </div>
          {windowWidth && windowWidth > MD && <Copyright />}
        </div>
        <div className={s.contacts}>
          <div className={s.row}>
            <h2 className={s.title}>Контакты рекрутмента</h2>
            <a
              onClick={() =>
                clickAnalytics({
                  action: 'mailto:hr@cloud.ru',
                  clickZone: 'footer',
                  clickElement: 'textclick',
                  clickContent: 'hr@cloud.ru',
                  uniqueId: 'footer-mail-link',
                  transitionType: 'outside-link',
                  clickZoneCategory: 'site-footer',
                  transitionUrl: 'mailto:hr@cloud.ru',
                  transitionTypeMetrics: 'external',
                })
              }
              className={cn(s.link)}
              href="mailto:hr@cloud.ru"
            >
              hr@cloud.ru
            </a>
          </div>
          <div className={s.row}>
            <h2 className={s.title}>Адрес</h2>
            <a
              className={cn(s.link)}
              href="https://yandex.ru/maps/-/CDUBN8ke"
              target="_blank"
              onClick={() =>
                clickAnalytics({
                  action: 'https://yandex.ru/maps/-/CDUBN8ke',
                  clickZone: 'footer',
                  clickElement: 'textclick',
                  clickContent: 'г. Москва, 2-ая Звенигородская ул. д.28',
                  uniqueId: 'footer-address-link',
                  transitionType: 'outside-link',
                  clickZoneCategory: 'site-footer',
                  transitionUrl: 'https://yandex.ru/maps/-/CDUBN8ke',
                  transitionTypeMetrics: 'external',
                })
              }
            >
              г. Москва, <br />
              2-ая Звенигородская ул. д.28
            </a>
          </div>
        </div>
        {windowWidth && windowWidth <= MD && <Copyright />}
        <Logo />
      </Wrapper>
    </footer>
  );
};

export { Footer };
